<dv-dialog-content>
  @if (marker) {
    <app-map
      [id]="mapId"
      class="poi-map"
      [markers]="[{ points: [marker] }]"
      [invalidateSize$]="splitterEvents.resizeEnd$"></app-map>
  }
  <dv-dynamic-form
    [elements]="elements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="!this.formGroup.valid || !this.formGroup.dirty">
    {{ 'General.Save' | translate }}
  </dv-button>
</dv-dialog-content>
